import {
  ShippingMethodOptionProps,
  ShippingMethodOption as BaseShippingMethodOption,
} from "@made-people/blueprint-checkout";
import { useCentraSelectionResponse } from "@made-people/grease-centra";
import { useTranslate } from "@made-people/grease-translations";
import { useCartState } from "@made-people/grease-cart";
import { Checkmark } from "../../../assets/icons/Checkmark";
import { getCarrierLogo } from "../../../utils/get-carrier-logo";
import { isAllCartItemsOMG } from "../../../utils/is-all-cart-items-in-omg";
import { useAllocationRule } from "../../../services/centra/allocation-rule/mm-allocation-rule-provider";
import { useShippingThreshold } from "../../../hooks/use-shipping-threshold";
import { useCountryContent } from "../../../hooks/use-country-content";

export const MMShippingMethodOption = (props: ShippingMethodOptionProps) => {
  const selectionResponse = useCentraSelectionResponse();
  const { isFreeShipping } = useShippingThreshold();
  const translate = useTranslate();
  const { cart } = useCartState();
  const { allocationRule, hasWarehouse } = useAllocationRule();
  const countryContent = useCountryContent();
  const country = selectionResponse?.selection?.address?.country || "";
  const allInOMG = isAllCartItemsOMG(cart?.items ?? [], country, {
    name: allocationRule?.name ?? null,
    hasLitWarehouse: hasWarehouse("LIT"),
  });

  const logo = getCarrierLogo(country, props.methodKey, props.label, allInOMG);

  const displayLabel =
    props.methodKey !== "EXPRESS" &&
    !allInOMG &&
    countryContent?.shippingDeliveryEstimate
      ? countryContent.shippingDeliveryEstimate
      : props.label;

  const displayPrice =
    isFreeShipping && props.methodKey !== "EXPRESS"
      ? translate("Checkout_CartTotals_FreeShipping")
      : props.price;

  return (
    <BaseShippingMethodOption
      logo={logo}
      icons={{ active: <Checkmark className="w-5 h-5" /> }}
      {...props}
      label={displayLabel}
      price={displayPrice}
    />
  );
};
